/**
 * Cart Property Linkifier
 * ────────────────────────
 * Findet im Cart/Cart-Drawer Line-Item-Properties, deren Wert eine URL ist
 * (z.B. "Design-Vorschau") und ersetzt den langen URL-String durch einen
 * sauberen anklickbaren Link.
 *
 * Wirkt in Dawn-basierten Themes und ähnlichen Online-Store-2.0-Themes.
 * Re-läuft automatisch wenn der Cart-Drawer aktualisiert wird.
 */

(function () {
  'use strict';

  // Selectors für übliche Cart-Property-Container in Dawn + verwandten Themes
  const PROPERTY_SELECTORS = [
    '.product-option',
    '.cart-item__details .product-option',
    'dl.product-option dd',
    '[data-cart-properties] li',
    '.properties dd',
    '.cart__item-property',
    '.line-item-property',
  ];

  function linkify() {
    const elements = document.querySelectorAll(PROPERTY_SELECTORS.join(','));
    elements.forEach(processElement);
  }

  function processElement(el) {
    if (el.dataset.ppzLinked === '1') return;

    const text = el.textContent || '';
    const urlMatch = text.match(/(https?:\/\/[^\s<>"']+)/);
    if (!urlMatch) return;

    el.dataset.ppzLinked = '1';
    const url = urlMatch[0];

    // Den Text-Knoten finden, der die URL enthält, und ersetzen
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while ((node = walker.nextNode())) {
      const idx = node.nodeValue.indexOf(url);
      if (idx !== -1) {
        const before = node.nodeValue.substring(0, idx);
        const after = node.nodeValue.substring(idx + url.length);

        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.cssText =
          'display:inline-flex;align-items:center;gap:4px;' +
          'color:inherit;text-decoration:underline;font-weight:500;';
        link.innerHTML =
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>' +
          ' ansehen';

        const parent = node.parentNode;
        if (before) parent.insertBefore(document.createTextNode(before), node);
        parent.insertBefore(link, node);
        if (after) parent.insertBefore(document.createTextNode(after), node);
        parent.removeChild(node);
        break;
      }
    }
  }

  function scheduleLinkify() {
    requestAnimationFrame(linkify);
  }

  // Initial laufen lassen
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', linkify);
  } else {
    linkify();
  }

  // Theme-typische Cart-Update-Events lauschen
  ['cart:updated', 'cart:refreshed', 'cart:open', 'cart-drawer:open', 'shopify:cart:update'].forEach(
    function (evt) {
      document.addEventListener(evt, scheduleLinkify);
    }
  );

  // Catch-all: bei DOM-Mutationen erneut prüfen (Cart-Drawer öffnet sich, etc.)
  if (window.MutationObserver) {
    let scheduled = false;
    const observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        linkify();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();